import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { ORDER_FILTERS, ORDER_STATUS_MAP } from './constants';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const OrdersPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const isFiltered = searchParams.get('type');
  const typeOfOrder = ORDER_FILTERS[isFiltered];

  const getData = (count = 5, offset = 0) => {
    apiRequests.products.getOrders(count, offset).then((res) => setData(res));
  };

  const getDataFiltered = (params) => {
    apiRequests.products.getOrdersFiltered(...params).then((res) => setData(res));
  };

  useEffect(() => {
    if (typeOfOrder) {
      const page = searchParams.get('page');
      getDataFiltered([typeOfOrder, undefined, page]);
    } else {
      getData();
    }
  }, [isFiltered]);

  const handleSearch = () => {
    getDataFiltered([typeOfOrder, searchValue]);
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск заказов..."
      />

      <nav className="nav at-nav nav-pills flex-column flex-sm-row mb-3">
        <button
          className={`flex-sm-fill text-sm-center nav-link ${!isFiltered && 'active'}`}
          onClick={() => setSearchParams((prev) => ({}))}
        >
          Все
        </button>
        <button
          className={`flex-sm-fill text-sm-center nav-link ${isFiltered === 'unpaid' && 'active'}`}
          onClick={() => setSearchParams((prev) => ({ ...prev, type: 'unpaid' }))}
        >
          Не оплачены
        </button>
        <button
          className={`flex-sm-fill text-sm-center nav-link ${isFiltered === 'paid_for' && 'active'}`}
          onClick={() => setSearchParams((prev) => ({ ...prev, type: 'paid_for' }))}
        >
          Оплачены
        </button>
        <button
          className={`flex-sm-fill text-sm-center nav-link ${isFiltered === 'in_delivery' && 'active'}`}
          onClick={() => setSearchParams((prev) => ({ ...prev, type: 'in_delivery' }))}
        >
          В доставке
        </button>
        <button
          className={`flex-sm-fill text-sm-center nav-link ${isFiltered === 'delivered' && 'active'}`}
          onClick={() => setSearchParams((prev) => ({ ...prev, type: 'delivered' }))}
        >
          Доставлены
        </button>
      </nav>

      <div className="mb-3" style={{ minHeight: '300px' }}>
        {!data.items || data.items.length === 0 ? (
          <p className="text-center fs-4 text-secondary">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => {
            const status = ORDER_STATUS_MAP[item.status] || { text: 'Новый', variant: 'warning' };
            return (
              <EntityCard
                key={item.id}
                title={`#${item.id}`}
                subtitle={item.user ? `${item.user.name} ${item.user.surname}` : 'Неизвестный пользователь'}
                badge={{ text: status.text, variant: status.variant }}
                fields={[
                  { label: 'Сумма', value: `${item.totalSum || 0} ${item.currency?.symbol || 'USD'}` },
                  { label: 'Создано', value: dateToString(item.createdAt) },
                ]}
                editLink={`/shop/orders/${item.id}`}
              />
            );
          })
        )}
      </div>

      <Pagination
        noRequest
        count={data.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, 10 * page)}
      />
    </>
  );
};

export default OrdersPage;
